import React from 'react';
import { Box, Heading } from '@wix/design-system';
import { ExactMatchHeadlineSkeleton } from './ExactMatchHeadlineSkeleton';
import { exactMatchHeadlineApiClient } from './ExactMatchHeadline.apiClient';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import s from './ExactMatchHeadline.css';
export const ExactMatchHeadline = _ref => {
  let domain = _ref.domain,
    _ref$dataHook = _ref.dataHook,
    dataHook = _ref$dataHook === void 0 ? 'exact-match-headline' : _ref$dataHook;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const _exactMatchHeadlineAp = exactMatchHeadlineApiClient.hooks.useExactMatchHeadline({
      domain
    }, true, {
      staleTime: Infinity,
      cacheTime: Infinity,
      useErrorBoundary: false
    }),
    data = _exactMatchHeadlineAp.data,
    isLoading = _exactMatchHeadlineAp.isLoading;
  const headline = (data == null ? void 0 : data.description) || (data == null ? void 0 : data.fallbackTitleKey) && t(data.fallbackTitleKey, {
    domainName: domain
  });
  if (isLoading) {
    return /*#__PURE__*/React.createElement(ExactMatchHeadlineSkeleton, {
      dataHook: `${dataHook}-skeleton`
    });
  }
  if (!headline) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    padding: "20px 0 24px 0",
    align: "center",
    textAlign: "center",
    dataHook: dataHook
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "medium",
    as: "h2",
    className: s.headline
  }, headline));
};
//# sourceMappingURL=ExactMatchHeadline.js.map